import React, { useEffect, useState } from 'react'
import Routes from '../routes'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'
import { BrowserRouter } from 'react-router-dom'
import { useClearCache } from 'react-clear-cache'
import { GlobalStyle } from '../../styles/global'
import { Slick } from '../../styles/slick'
import {
  AlertBoxProvider,
  ModalBoxProvider,
  GalleryProvider,
  TourProvider,
  GameProvider,
  PageProvider,
  GameWrapperProvider,
  TermsProvider,
  MissionTriggerProvider
} from '../../contexts'
// import awsExports from '../../../main/configs/aws-exports'
import { Amplify } from 'aws-amplify'
import { I18n } from 'aws-amplify/utils'
import { BgModal, ModalContent, ModalError } from '../../contexts/style'
import { t } from '../../adapters/translate/translate'
import { dictionary } from '../../dictionary'
import amplifyconfig from '../../../main/configs/amplifyconfiguration.json'

// Configurando o Amplify
Amplify.configure(amplifyconfig)

// Configurando o I18n
try {
  I18n.putVocabularies(dictionary)
  I18n.setLanguage('en')
} catch (error) {
  console.error('Error configuring I18n:', error)
}

const App = () => {
  const { isLatestVersion, emptyCacheStorage } = useClearCache()
  const [openModalError, setOpenModalError] = useState<any>({
    open: false,
    text: '',
    button: t('Close')
  })

  useEffect(() => {
    if (!isLatestVersion) {
      setOpenModalError({
        open: true,
        text: 'Uma nova versão está disponível, clique em OK para atualizar!',
        button: 'OK'
      })
    }
  }, [isLatestVersion])

  return (
    <React.StrictMode>
      <BrowserRouter>
        <GlobalStyle />
        <Slick />
        <GameProvider>
          <PageProvider>
            <AlertBoxProvider>
              <ModalBoxProvider>
                <GalleryProvider>
                  <TourProvider>
                    <MissionTriggerProvider>
                      <GameWrapperProvider>
                        <TermsProvider>
                          <Routes />
                        </TermsProvider>
                      </GameWrapperProvider>
                    </MissionTriggerProvider>
                  </TourProvider>
                </GalleryProvider>
              </ModalBoxProvider>
            </AlertBoxProvider>
          </PageProvider>
        </GameProvider>
        {openModalError.open &&
        <ModalError>
          <BgModal />
          <ModalContent>
            <h2>{openModalError.text}</h2>
            <button
              onClick={() => { emptyCacheStorage() }}
            >
              {openModalError.button}
            </button>
          </ModalContent>
        </ModalError>
        }
      </BrowserRouter>
    </React.StrictMode>
  )
}

export default App
